import LegalDoc from "@/components/LegalDoc";

export const SHIPPING_POLICY_VERSION = "2026-08-06";

const SECTIONS = [
  {
    h: "1. When your order ships",
    p: [
      "Nothing ships until two things have happened: a licensed pharmacy technician has approved your prescription, and your payment has cleared. Prescription review normally takes up to 24 hours. Once your order is with the pharmacy partner, dispensing and dispatch normally take 1 to 3 business days.",
    ],
  },
  {
    h: "2. How long delivery takes",
    p: [
      "Standard delivery normally arrives within 7 to 14 business days after dispatch. Express delivery normally arrives within 3 to 7 business days after dispatch.",
      "Those are estimates, not guarantees. They are the times our carriers quote us in normal conditions, and most orders arrive inside them. Some do not.",
    ],
  },
  {
    h: "3. Why an order can take longer",
    p: [
      "Delivery can take longer than the estimate for reasons that sit outside our control. We do not control the courier and we do not control customs.",
      "What we do control is telling you. If your order is running late we contact you, we chase it, and we keep chasing it until it lands or until we refund it.",
    ],
    ul: [
      "Prescription verification and pharmacy review",
      "Stock availability at the dispensing pharmacy",
      "Payment or fraud checks",
      "Customs and border inspection",
      "Courier handling, backlogs and missed scans",
      "Severe weather, strikes and other disruptions",
      "Legal or regulatory restrictions",
    ],
  },
  {
    h: "4. Tracking",
    p: [
      "You get a tracking number by email as soon as your order is dispatched. You can also see it on your dashboard.",
    ],
  },
  {
    h: "5. Cancelling",
    p: [
      "You can cancel free of charge at any time before your order is dispatched. Email support@pawlinx.com or call 1-888-827-2717. Once an order has been dispensed by a pharmacy it cannot usually be cancelled, because prescription medication cannot be returned to stock.",
    ],
  },
  {
    h: "6. Refunds",
    p: [
      "If we cannot fulfil your order, you get a full refund automatically. You do not have to ask.",
      "You also get a full refund if your order never arrives, if it arrives damaged, if the wrong item was sent, or if a pharmacy partner cannot dispense the quantity your prescription authorizes and you do not want the reduced quantity.",
      "Refunds go back to the original payment method. Your bank normally takes 5 to 10 business days to post it.",
    ],
  },
  {
    h: "7. Returns",
    p: [
      "For safety and legal reasons, prescription medication cannot be returned once it has left the pharmacy, and cannot be resold. Please do not post medication back to us. If something is wrong with your order, contact us first and we will tell you what to do with it.",
    ],
  },
  {
    h: "8. Damaged, wrong or missing orders",
    p: [
      "Contact us within 14 days of delivery, or within 30 days of dispatch if the order never arrived. A photo helps if the package or the product is damaged. We will replace it or refund it.",
    ],
  },
  {
    h: "9. How much we can dispense at once",
    p: [
      "The most we dispense in a single order is a three month supply of a medication, however many refills your prescription carries. If you need more than that, place another order when you are ready.",
      "How much a three month supply actually is depends on the dose your veterinarian prescribed, so we cannot work it out from the quantity alone. A licensed pharmacy technician reads your prescription and sets the final quantity before payment opens. If they reduce what you asked for, we tell you why and re-price the order first, and you are not charged until you agree.",
      "Some medications come as a sealed device, an inhaler for example, which cannot be split. In those cases we dispense whole devices, so the amount can land slightly either side of three months.",
    ],
  },
  {
    h: "10. Prices",
    p: [
      "The price you are quoted is the price you pay for that order. Prices can change between orders. If you hold a price agreement with us, it is shown on your dashboard and it is honoured.",
    ],
  },
  {
    h: "11. Contact",
    p: [
      "support@pawlinx.com or 1-888-827-2717, Mon to Fri 8AM to 6PM, Sat 8AM to 3PM PST.",
    ],
  },
];

export default function ShippingRefundPage() {
  return (
    <LegalDoc
      testid="shipping-refund-page"
      title="Shipping, Refund, Cancellation and Returns Policy"
      subtitle="PAWLINX MED INC."
      effective="6 August 2026"
      version={SHIPPING_POLICY_VERSION}
      sections={SECTIONS}
    />
  );
}
